import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'lowerCase'
})

export class LowerCase implements PipeTransform {

  transform(value: string): string {

      if (value == null || value == "") return "";
      return (value).toLocaleLowerCase().toString();
   }
}



// WEBPACK FOOTER //
// ./src/app/custom-pipes/lowerCase.pipe.ts